import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserAccess } from '../../hooks/useRole';
import NewLayout from '../../layout/dashboard/NewLayout';
import DefectIntelligence from '../../components/defects/Defectclassifier';

const DefectIntelligencePage = () => {
  const navigate = useNavigate();
  const { canSeeAllDefects, isError, isLoading } = useUserAccess();

  useEffect(() => {
    if (!isLoading && !isError && !canSeeAllDefects) {
      navigate('/access-denied');
    }
  }, [canSeeAllDefects, isLoading, isError, navigate]);

  return (
    <NewLayout>
      <DefectIntelligence />
    </NewLayout>
  );
};

export default DefectIntelligencePage;
